import { useCallback } from "react";

import useAsync from "Common/useAsync";

import { getFlipper } from "./api";

export const useFlipper = (flipperNames) => {
  const asyncFunction = useCallback(() => getFlipper(flipperNames).then((response) => response.json()), []);

  const result = useAsync(asyncFunction);
  return {
    flipperValues: result?.data,
  };
};
